import type { CvContent } from './types'

export const en: CvContent = {
  tagline: 'Performer · Dancer · Singer · Dance teacher',
  intro:
    'BA Dance / BA Dance Teaching student at Lucia Marthas Institute for Performing Arts. Stage experience at venues including the Ziggo Dome, Ahoy and AFAS Live, and dance captain of the annual LMIPA showcase.',
  about:
    'I am an enthusiastic and flexible performer with a strong sense of responsibility. A real go-getter, I am reliable and always punctual. I work in an organised way, keep my tasks in order and am a team player who adapts quickly when needed. Alongside my work on stage I also love teaching, passing on my passion for musical theatre and the performing arts to others. With my positive energy and dedication I contribute to a smooth and successful production.',
  features: [
    { label: 'Hair colour', value: 'Blonde' },
    { label: 'Eyes', value: 'Blue' },
    { label: 'Height', value: '1.70 m' },
    { label: 'Date of birth', value: '27/03/2005' },
  ],
  skills: [
    {
      heading: 'Voice',
      lines: ['Voice type: Soprano', 'Vocal range: E3 to C6', 'Training in:'],
      items: ['Jazz', 'Musical theatre', 'Pop', 'Classical', 'Ensemble and harmony singing'],
    },
    {
      heading: 'Dance',
      lines: ['Training in:'],
      items: [
        'Ballet',
        'Jazz',
        'Horton',
        'Modern',
        'Various Latin styles and lift work',
        'Musical theatre',
        'Commercial',
        'Tap',
      ],
    },
    {
      heading: 'Acting',
      lines: [],
      items: [
        'Improvisation',
        'Group scenes',
        'Monologues',
        'Duologues',
        'Theatre and on-camera acting',
      ],
    },
  ],
  experience: [
    {
      title: 'Annual showcase LMIPA',
      period: 'Jul 2014 – present',
      description:
        'For the annual showcase I have been dance captain, responsible for several pieces. I also created choreography for the younger departments, drawing on my creativity and experience as a dance teacher.',
    },
    { title: 'Christmas Show, Ziggo Dome', period: 'Dec 2016' },
    { title: 'Kinderen voor Kinderen 40 years, Ahoy', period: '2018' },
    { title: 'Lang Leve de Muziek Show AVROTROS', period: '2018 – 2019' },
    { title: 'Katja en Babbette Discobal, AFAS Live', period: 'Nov 2025' },
    {
      title: 'Workshops',
      period: '2023 – present',
      bullets: [
        'Workshops/classes with Malou Linders, Denden Karadeniz, Sergio Reis, Jordy Sparidaens, Anneke Ghysens and Laurent Flamment',
        'Workshops/classes with Caroline Dijkhuizen, Andy Señor JR, Mary-Ann Lamb, Valerie Pettifort and Michiel Varga',
      ],
    },
    {
      title: 'Dance teacher, Lucia Marthas Institute for Performing Arts',
      period: 'Sept 2023 – present',
    },
  ],
  education: [
    {
      period: '2023',
      school: 'Gerrit van der Veen College',
      detail: 'VWO / DAMU class LMIPA',
    },
    {
      period: 'Sept 2023 – July 2027',
      school: 'Lucia Marthas Institute for Performing Arts',
      detail: 'BA Dance / BA Dance Teaching',
    },
  ],
}
